

export const setAccount = userKey => ({ userKey });



// WEBPACK FOOTER //
// ./src/store/main/data/actions.js